import { render } from "./Agenda.vue?vue&type=template&id=0577dcdf&scoped=true"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"

import "./Agenda.vue?vue&type=style&index=0&id=0577dcdf&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0577dcdf"]])

export default __exports__